module.exports = __webpack_public_path__ + "static/media/rewards.b9ed40c3.svg";